import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  error: false,
  pendingOrderList: [],
  confirmOrderList: [],
  rejectedOrderList: [],
  cancelOrderList: [],
  allOrderList: [],
  totalPendingOrders: 0,
  totalConfirmOrders: 0,
  totalRejectedOrders: 0,
  totalCancelOrders: 0,
  totalAllOrders: 0,
  orderDetails: [],
  orderReport: [],
};
const orders = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state) {
      state.isLoading = false;
      state.error = true;
    },
    getPendingOrderList(state, action) {
      state.isLoading = false;
      state.pendingOrderList = action.payload;
      state.error = false;
    },
    setTotalPendingOrders(state, action) {
      state.totalPendingOrders = action.payload;
    },
    getConfirmOrderList(state, action) {
      state.isLoading = false;
      state.confirmOrderList = action.payload;
      state.error = false;
    },
    setTotalConfirmOrders(state, action) {
      state.totalConfirmOrders = action.payload;
    },
    getRejectedList(state, action) {
      state.isLoading = false;
      state.rejectedOrderList = action.payload;
      state.error = false;
    },
    setTotalRejectedOrders(state, action) {
      state.totalRejectedOrders = action.payload;
    },
    getCancelledOrderList(state, action) {
      state.isLoading = false;
      state.cancelOrderList = action.payload;
      state.error = false;
    },
    setTotalCancelOrders(state, action) {
      state.totalCancelOrders = action.payload;
    },
    getAllOrderList(state, action) {
      state.isLoading = false;
      state.allOrderList = action.payload;
      state.error = false;
    },
    setTotalAllOrders(state, action) {
      state.totalAllOrders = action.payload;
    },
    editOrder(state, action) {
      state.isLoading = false;
      state.orderList = action.payload;
    },
    getOrderDetails(state, action) {
      state.isLoading = false;
      state.orderDetails = action.payload;
      state.error = false;
    },
    downLoadOrderReport(state, action) {
      state.isLoading = false;
      state.orderReport = action.payload;
      state.error = false;
    },
    removeOrderProduct(state, action) {
      const { productId } = action.payload || {};
      const products = state.orderDetails?.config?.products;
      if (!Array.isArray(products) || !productId) return;

      const normalizedTargetId = String(productId);
      state.orderDetails = {
        ...state.orderDetails,
        config: {
          ...state.orderDetails.config,
          products: products.filter((p) => String(p?.id ?? p?.product_id ?? '') !== normalizedTargetId),
        },
      };
    },
    stopLoading(state) {
      state.isLoading = false;
    },
  },
});

export default orders.reducer;
export const {
  startLoading,
  hasError,
  getCancelledOrderList,
  setTotalCancelOrders,
  getConfirmOrderList,
  setTotalConfirmOrders,
  getPendingOrderList,
  setTotalPendingOrders,
  getRejectedList,
  setTotalRejectedOrders,
  getAllOrderList,
  setTotalAllOrders,
  editOrder,
  getOrderDetails,
  downLoadOrderReport,
  stopLoading,
  removeOrderProduct,
} = orders.actions;
